(() => {
  const initialize = () => {
    const container = document.getElementById('cart-drawer-container');
    if (!container || container.dataset.sspCartAccessibility) return;
    container.dataset.sspCartAccessibility = 'true';

    const focusSelector = 'a[href],button,input:not([type="hidden"]),select,textarea,[tabindex],iframe';
    let drawer = null;
    let opened = false;
    let returnFocus = null;
    let lastFocus = null;
    let itemControl = null;
    let addon = null;
    let addonTrigger = null;
    let scheduled = false;

    const visible = element => element instanceof HTMLElement &&
      element.isConnected && !element.closest('[hidden],[inert],[aria-hidden="true"]') &&
      element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const focusable = scope => Array.from(scope.querySelectorAll(focusSelector)).filter(element =>
      visible(element) && !element.matches(':disabled') &&
      !element.closest('.scd__addon:not(.open)') && element.tabIndex >= 0);
    const focus = element => {
      if (visible(element) && !element.matches(':disabled')) element.focus({ preventScroll: true });
    };
    const otherDialogActive = () => {
      const active = document.activeElement;
      const dialog = active?.closest('dialog[open],[role="dialog"],[role="alertdialog"]');
      const ownDialog = drawer?.querySelector('.scd__content');
      return dialog && dialog !== drawer && dialog !== ownDialog;
    };
    const rememberControl = element => {
      lastFocus = element;
      const item = element.closest('[data-cart-item]');
      if (!item) {
        itemControl = null;
        return;
      }
      const kind = element.matches('.scd-item__qty_input') ? 'quantity' :
        element.matches('.scd-item__btn') ? element.dataset.qtyChange :
        element.matches('.scd-item__remove') ? 'remove' : null;
      itemControl = kind ? { key: item.dataset.id, kind } : null;
    };
    const matchingControl = () => {
      if (!itemControl) return null;
      const item = Array.from(drawer.querySelectorAll('[data-cart-item]'))
        .find(element => element.dataset.id === itemControl.key);
      if (!item) return null;
      if (itemControl.kind === 'quantity') return item.querySelector('.scd-item__qty_input');
      if (itemControl.kind === 'remove') return item.querySelector('.scd-item__remove');
      return Array.from(item.querySelectorAll('.scd-item__btn'))
        .find(element => element.dataset.qtyChange === itemControl.kind);
    };
    const synchronize = () => {
      scheduled = false;
      drawer = container.querySelector('.scd__wrapper');
      const isOpen = drawer && !drawer.classList.contains('hidden') && !drawer.hidden;
      if (isOpen && !opened) {
        opened = true;
        returnFocus = document.activeElement;
        focus(drawer.querySelector('.scd__close'));
      } else if (!isOpen && opened) {
        opened = false;
        addon = null;
        addonTrigger = null;
        itemControl = null;
        lastFocus = null;
        if (!otherDialogActive()) focus(returnFocus);
        returnFocus = null;
      }
      if (!isOpen) return;

      const nextAddon = drawer.querySelector('.scd__addon.open');
      if (nextAddon !== addon) {
        const previousTrigger = addonTrigger;
        addon = nextAddon;
        addonTrigger = addon ? Array.from(drawer.querySelectorAll('.scd__footer-actions [data-open]'))
          .find(element => `scd-${element.dataset.open}` === addon.id) : null;
        if (!otherDialogActive()) {
          if (addon && !addon.contains(document.activeElement)) focus(focusable(addon)[0]);
          else if (!addon && previousTrigger) focus(previousTrigger);
        }
      }
      if (lastFocus && !lastFocus.isConnected && !otherDialogActive() &&
          (document.activeElement === document.body || document.activeElement === container)) {
        focus(matchingControl() || drawer.querySelector('.scd__close'));
      }
    };

    container.addEventListener('focusin', event => {
      if (opened && drawer?.contains(event.target)) rememberControl(event.target);
    });
    document.addEventListener('keydown', event => {
      if (!opened || !drawer || event.defaultPrevented || otherDialogActive()) return;
      const active = document.activeElement;
      const activeAddon = drawer.querySelector('.scd__addon.open');
      if (event.key === 'Escape') {
        const closeButton = activeAddon?.querySelector('.btn-cancel') ||
          (!activeAddon && drawer.querySelector('.scd__close'));
        if (closeButton) {
          event.preventDefault();
          closeButton.click();
        }
        return;
      }
      if (event.key !== 'Tab') return;
      const scope = activeAddon || drawer;
      const controls = focusable(scope);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) {
        event.preventDefault();
        focus(drawer.querySelector('.scd__close'));
      } else if (!controls.includes(active)) {
        event.preventDefault();
        focus(event.shiftKey ? last : first);
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        focus(last);
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        focus(first);
      }
    });
    new MutationObserver(() => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(synchronize);
      }
    }).observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    synchronize();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
